module.exports = __webpack_public_path__ + "img/icon-contract.a54483e1.png";